import { ADD_PRODUCT, DELETE_PRODUCT, ADD_TO_CART, DECREMENT_PRODUCT_COUNT, INCREMENT_PRODUCT_COUNT, REMOVE_FROM_CART } from './actionTypes';

export const addProduct = (product) => {
    return {
        type: ADD_PRODUCT,
        payload: product
    };
};

export const deleteProduct = (product) => {
    return {
        type: DELETE_PRODUCT,
        payload: product
    };
};

export const removeProduct = (id) => {
    return {
        type: REMOVE_FROM_CART,
        payload: id
    };
};

export const addToCart = (id) => {
    return {
        type: ADD_TO_CART,
        payload: id
    };
};

export const removeFromCart = (id) => {
    return {
        type: REMOVE_FROM_CART,
        payload: id
    };
};

export const incrementProductCount = (id) => {
    return {
        type: INCREMENT_PRODUCT_COUNT,
        payload: id
    };
};

export const decrementProductCount = (id) => {
    return {
        type: DECREMENT_PRODUCT_COUNT,
        payload: id
    };
};
